<div class="commentaires-container">

  <button mat-icon-button class="close-button" (click)="fermer()">
    <mat-icon>close</mat-icon>
  </button>

  <h2>Commentaires du client {{ codeDivalto }}</h2>

  <button mat-raised-button color="primary" (click)="openCommentaire()">
    Ajouter un commentaire
  </button>

  <mat-divider style="margin: 16px 0;"></mat-divider>

  <div class="comments-list">
    @if (commentaires && commentaires.length > 0) {
      @for (c of commentaires ; track c.id) {
        <div class="comment-item">
          <div class="comment-header">
            <span class="comment-author">{{ c.auteur }}</span>
            <span class="comment-date">{{ c.dateCreation | date:'dd/MM/yyyy HH:mm:ss' }}</span>
          </div>

          <div class="comment-text">
            {{ c.texte }}
          </div>

          <div class="comment-actions">
            <button mat-icon-button color="primary" (click)="openCommentaire(c)">
              <mat-icon>edit</mat-icon>
            </button>

            <button mat-icon-button color="warn" (click)="deleteCommentaire(c)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      }
    } @else {
      <p>Aucun commentaire pour ce client.</p>
    }
  </div>
</div>
